declare global {
	interface Array<T> {
		softCopy(): T[];
		hardCopy(): T[];
		groupBy<TKey>(keyGetter: (o: T) => TKey): Map<TKey, T[]>;
	}
}

/** Copies items to a new array */
function softCopyArray<T>(this: T[]): T[] {
	return this.slice();
}

/** Copies every item into a new object, so changing an item's own properties does not modify the original */
function hardCopyArray<T>(this: T[]): T[] {
	return this.map((i) => ({ ...i }));
}

function groupByArray<T, TKey>(this: T[], keyGetter: (o: T) => TKey): Map<TKey, T[]> {
	const map = new Map<TKey, T[]>();
	this.forEach((item) => {
		const key = keyGetter(item);
		const collection = map.get(key);
		if (collection) {
			collection.push(item);
		} else {
			map.set(key, [item]);
		}
	});
	return map;
}

function defineArrayMethod(name: "softCopy" | "hardCopy" | "groupBy", value: (...args: never[]) => unknown) {
	if (Array.prototype[name]) return;
	// oxlint-disable-next-line no-extend-native -- installing these methods on arrays is this module's purpose
	Object.defineProperty(Array.prototype, name, { value, enumerable: false });
}

defineArrayMethod("softCopy", softCopyArray);
defineArrayMethod("hardCopy", hardCopyArray);
defineArrayMethod("groupBy", groupByArray);

// oxlint-disable-next-line unicorn/require-module-specifiers -- declare global only works in a module
export {};
